import { resolveAdminMediaUrl } from '@formosa/shared/utils/mediaUrl';

export const ENGLISH_LANG_CODE = 'en_US';

export const DEFAULT_DETAIL_FORM = {
  lang: ENGLISH_LANG_CODE,
  title: '',
  body: '',
  image: '',
  displayName: '',
};

export function getLanguageLabel(language) {
  return language?.langNameCh || language?.langName || language?.langCode || '';
}

export function normalizeEnabledLanguages(languages) {
  const rows = Array.isArray(languages) ? [...languages] : [];
  const hasEnglish = rows.some((item) => item?.langCode === ENGLISH_LANG_CODE);
  if (!hasEnglish) {
    rows.unshift({
      langCode: ENGLISH_LANG_CODE,
      langName: 'English',
      langNameCh: '英語',
      status: 1,
      sort: 0,
    });
  }
  return rows.sort((a, b) => {
    const sortDiff = (a?.sort ?? 0) - (b?.sort ?? 0);
    if (sortDiff !== 0) {
      return sortDiff;
    }
    return String(a?.langCode || '').localeCompare(String(b?.langCode || ''));
  });
}

export function buildDefaultForm(languages) {
  const enabledLanguages = normalizeEnabledLanguages(languages);
  return {
    sort: '0',
    merchantInterface: '',
    details: enabledLanguages.map((item) => ({
      ...DEFAULT_DETAIL_FORM,
      lang: item.langCode,
    })),
  };
}

export function buildOfflineMerchantPageParams(pageNo, filters) {
  const params = { pageNo, pageSize: 15 };
  if (filters.title?.trim()) {
    params.title = filters.title.trim();
  }
  return params;
}

export function rowToForm(row, languages) {
  const enabledLanguages = normalizeEnabledLanguages(languages);
  if (!row) {
    return buildDefaultForm(enabledLanguages);
  }
  const detailMap = new Map((row.staticIntroDetails || []).map((d) => [d.lang, d]));
  const englishDetail = detailMap.get(ENGLISH_LANG_CODE);
  return {
    sort: row.sort != null ? String(row.sort) : '0',
    merchantInterface: englishDetail?.title ?? '',
    details: enabledLanguages.map((item) => {
      const existing = detailMap.get(item.langCode);
      return {
        lang: item.langCode,
        title: existing?.title ?? '',
        body: existing?.body ?? '',
        image: existing?.image ?? '',
        displayName: existing?.displayName ?? '',
      };
    }),
  };
}

export function formToPayload(form, editingId, languages) {
  const enabledLanguages = normalizeEnabledLanguages(languages);
  const detailMap = new Map((form.details || []).map((d) => [d.lang, d]));
  const staticIntroDetails = enabledLanguages.map((language) => {
    const existing = detailMap.get(language.langCode) || {};
    const isEnglish = language.langCode === ENGLISH_LANG_CODE;
    return {
      lang: language.langCode,
      title: isEnglish ? form.merchantInterface?.trim() || '' : '',
      body: existing.body?.trim() || '',
      image: existing.image?.trim() || null,
      displayName: existing.displayName?.trim() || null,
    };
  });

  const payload = {
    sort: Number(form.sort) || 0,
    staticIntroDetails,
  };
  if (editingId != null) {
    payload.id = editingId;
  } else {
    payload.isRecharge = false;
    payload.isWithdrawal = false;
    payload.isHomeShow = false;
  }
  return payload;
}

export function resolveImageUrl(image) {
  return resolveAdminMediaUrl(image);
}
